// Google Analytics 4 (property G-C2WWT9YJR0).
//
// Consent and the gtag bootstrap both live in index.html, matching akku-24 and
// the rest of the network: TermsFeed cookie-consent owns the choice, and the
// tracker is gated behind its `tracking` consent level via Consent Mode v2.
// Nothing here decides whether GA may run — Consent Mode does.
//
// gtag.js loads on the akkumost.hu host only, so dev and vite preview never
// reach the property and window.gtag is simply absent.

declare global {
	interface Window {
		dataLayer?: unknown[]
		gtag?: (...args: unknown[]) => void
		cookieconsent?: { openPreferencesCenter: () => void }
	}
}

/** Report a page view (fired once — single-screen site). A no-op wherever
    gtag.js was not loaded. */
export function trackPageView(path: string): void {
	window.gtag?.('event', 'page_view', {
		page_path: path,
		page_location: window.location.href,
		page_title: document.title,
	})
}

/** TermsFeed stores the choice in the `cookie_consent_level` cookie (JSON). */
function hasTrackingConsent(): boolean {
	try {
		const row = document.cookie
			.split('; ')
			.find((entry) => entry.startsWith('cookie_consent_level='))
		if (!row) return false
		const parsed: unknown = JSON.parse(decodeURIComponent(row.slice(row.indexOf('=') + 1)))
		return (parsed as { tracking?: boolean }).tracking === true
	} catch {
		return false
	}
}

/**
 * Consent-gated GA4 event, named like the PHP sites' GASend (Category_Action).
 * The single helper for every funnel event (Phone_*, Order_*) so the consent
 * check lives in one place.
 */
export function gaTrackEvent(name: string): void {
	if (!hasTrackingConsent()) return
	window.gtag?.('event', name)
}

/** Reopen TermsFeed's preferences centre, where consent can be withdrawn. */
export function openCookiePreferences(): void {
	window.cookieconsent?.openPreferencesCenter()
}
